import { DetailedHTMLProps, TextareaHTMLAttributes } from 'react';
import { observer } from 'mobx-react-lite';

export const AutogrowTextarea = observer(
  (
    props: DetailedHTMLProps<
      TextareaHTMLAttributes<HTMLTextAreaElement>,
      HTMLTextAreaElement
    > & { error?: boolean },
  ) => {
    const updateHeight = (el: HTMLTextAreaElement) => {
      const update = () => {
        const bounding = el.getBoundingClientRect();
        if (bounding.width > 0) {
          clearInterval(interval);

          const style = window.getComputedStyle(el);

          const copy = el.cloneNode(true) as HTMLTextAreaElement;

          copy.style.boxSizing = style.boxSizing;
          copy.style.padding = style.padding;
          copy.style.border = style.border;
          copy.style.lineHeight = style.lineHeight;
          copy.style.font = style.font;
          copy.style.whiteSpace = style.whiteSpace;

          copy.style.position = 'fixed';
          copy.style.left = '-9999px';
          copy.style.top = '0';
          copy.style.height = 'auto';
          copy.style.opacity = '0';
          copy.style.overflow = 'hidden';
          copy.style.width = `${el.clientWidth}px`;

          document.body.append(copy);

          // 🔴 measure ONLY the copy
          const height = copy.scrollHeight;

          copy.remove();

          // 🔴 apply once
          el.style.height = `${height + 5}px`;
        }
      };

      const interval = setInterval(update, 100);
      update();
    };

    return (
      <textarea
        {...props}
        className={`${props.className ?? ''} autogrow_textarea ${props.error ? 'invalid_field' : ''}`}
        onKeyDown={(ev) => {
          props?.onKeyDown?.(ev);
          if (!ev.isDefaultPrevented() && ev.code === 'Enter' && ev.ctrlKey) {
            (ev.target as HTMLElement)
              .closest<HTMLFormElement>('form')
              ?.querySelector<HTMLButtonElement>('button[type="submit"]')
              ?.click();
          }
        }}
        ref={(el) => {
          if (el instanceof HTMLTextAreaElement) {
            updateHeight(el);
          }
        }}
        onChange={(ev) => {
          props?.onChange?.(ev);
          updateHeight(ev.target as HTMLTextAreaElement);
        }}
      />
    );
  },
);
